import React, { memo } from "react";
import colors from "app/colors";
import { AddReactionIcon } from "modules/icons";
import CircularIconButton from "../_shared/buttons/circular-icon-button";
import {
  FileGalleryFragment,
  MessageFragment,
  MessageThreadFragment,
} from "gql/graphql";
import {
  FILE_GALLERY_BUTTON_BOX_SIZE,
  FILE_GALLERY_BUTTON_BACKGROUND_COLOR,
  FILE_GALLERY_BUTTON_WIDTH,
  REACTION_TYPES,
} from "modules/utils/Constants";
import {
  VStack,
  Text,
  Popover,
  PopoverTrigger,
  HStack,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  Portal,
} from "@chakra-ui/react";
import { useToggle } from "react-use";
import MessagePopoverReactionButton from "../messaging/messages/message-popover/message-popover-reaction-button";
import useRemovedFromThread from "modules/hooks/use-removed-from-thread";

interface IProps {
  messageThread: MessageThreadFragment;
  message?: MessageFragment;
  file: FileGalleryFragment;
}

const FileGalleryAddReactionButton = ({
  messageThread,
  message,
  file,
}: IProps) => {
  const [isOpen, toggleIsOpen] = useToggle(false);
  const { isMeRemoved } = useRemovedFromThread(messageThread);

  if (isMeRemoved) {
    return null;
  }

  if (!message) {
    return (
      <CircularIconButton
        icon={
          <AddReactionIcon
            boxSize={FILE_GALLERY_BUTTON_BOX_SIZE}
            fill={colors.white}
          />
        }
        aria-label="add reaction"
        backgroundColor={FILE_GALLERY_BUTTON_BACKGROUND_COLOR}
        variant="hover"
        disabled
      />
    );
  }

  return (
    <VStack spacing={1} w={FILE_GALLERY_BUTTON_WIDTH}>
      <Popover
        trigger="click"
        isOpen={isOpen}
        onOpen={toggleIsOpen}
        onClose={toggleIsOpen}
      >
        <PopoverTrigger>
          <CircularIconButton
            icon={
              <AddReactionIcon
                boxSize={FILE_GALLERY_BUTTON_BOX_SIZE}
                fill={colors.white}
              />
            }
            aria-label="add reaction"
            backgroundColor={FILE_GALLERY_BUTTON_BACKGROUND_COLOR}
            variant="hover"
          />
        </PopoverTrigger>
        <Portal>
          <PopoverContent w="full">
            <PopoverArrow />
            <PopoverBody>
              <HStack spacing={2} h="full" px={2}>
                {REACTION_TYPES.map((reaction) => (
                  <MessagePopoverReactionButton
                    key={reaction}
                    message={message}
                    file={file}
                    type={reaction}
                  />
                ))}
              </HStack>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
      <Text color={colors.grayPrimary} fontWeight={500} fontSize={10}>
        Add Reaction
      </Text>
    </VStack>
  );
};

export default memo(FileGalleryAddReactionButton);
